import { z } from "zod";

export const MODULATOR_SENSOR_TYPE_ID = 22;
export const modulatorTypeDtoSchema = z.object({
  id: z.number(),
  label: z.string(),
  meter: z.boolean(),
  modbus: z.boolean(),
  note: z.string(),
  v2V5: z.boolean(),
  vx: z.boolean(),
  vxRelay: z.boolean(),
  vxWire: z.boolean(),
  zigbeeStandard: z.boolean(),
});

export type TModulatorTypeDto = z.infer<typeof modulatorTypeDtoSchema>;
